import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { StepComponent } from '@icc/configurator/shared';
import { EventBusService, APP_CONFIG, AppConfigFactory } from '@icc/shared';
import { RollerDimensionsService } from '../dimensions.service';
import { ShutterFacade } from '../+state/shutter.facade';
import { iccListItem } from '@icc/configurator/ui';
import { map } from 'rxjs/operators';
import { SchemasService } from '../schemas.service';
import { Subscription } from 'rxjs';
import { ColorsService } from '../colors.service';
import { _ } from "@icc/shared/helpers";

@Component({
    selector: 'icc-systems',
    templateUrl: './systems.component.html',
    styleUrls: ['./systems.component.scss'],
    standalone: false
})
export class SystemsComponent extends StepComponent implements OnInit, OnDestroy {
  static stepName = _('ROLLER_SHUTTER_LEGACY|System');
  static stepIcon = {
      ligature: 'apps',
  };

  public configurator = 'roller_shutter';
  public stepId = 'system';
  public title = _('ROLLER_SHUTTER_LEGACY|System');

  systems: iccListItem[] = [];
  selectedSystem$ = this.shutterFacade.selectedSystem$;
  shutters$ = this.shutterFacade.shutters$;
  letters = ['A', 'B', 'C'];

  selectedConfiguratorType$ = this.shutterFacade.selectedConfiguratorType$;
  profile$ = this.shutterFacade.profile$;
  mosquito$ = this.shutterFacade.mosquito$;
  mosquitoSizeRange: {minWidth: number, maxWidth: number, minHeight: number, maxHeight: number } = this.rollerDimensionsService.getMosquitoSizeRestriction();
  showDimensionSizeRange = this.config().IccConfig.Configurators.roller_shutter.configuratorDimensionalRestriction;

  private subscriptions: Subscription[] = [];

  constructor(
      @Inject(APP_CONFIG) private config: AppConfigFactory,
      private eventBusService: EventBusService,
      private rollerDimensionsService: RollerDimensionsService,
      private shutterFacade: ShutterFacade,
      private schemasService: SchemasService,
      private colorsService: ColorsService,
  ) {
    super();
    if (this.schemasService.loadedData) {
        this.init();
    }
    this.subscriptions.push(
        this.eventBusService.subscribeWithoutConfiguration('initializedConfigurator', () =>
            this.init()
        )
    );
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.map(el => el.unsubscribe());
  }

  private init() {

  }

  changeSystem() {
    this.schemasService.openModalSystems();
  }

  /**
   * Funkcja ustawia profil
   */
  changeProfile() {
    this.rollerDimensionsService.selectProfile();
    if (!this.config().IccConfig.Configurators.roller_shutter.autoProfileSelection) {
        this.colorsService.init();
    }
  }

  toggleMosquito(value: boolean, index: number) {
    this.rollerDimensionsService.toggleMosquito(value, index);
  }

}
